import React from 'react';
import styled from 'styled-components';
import { Button, Card, CardIcon, CardValue, IconTypes, Text } from 'components';
import { lineHeight, theme, toRem } from 'design';

interface IPayoutMethodCardProps {
  disabled?: boolean;
  icon?: IconTypes;
  isLoading?: boolean;
  onClick: () => void;
  subTitle?: string;
  title: string;
  tooltipId?: string;
}

const StyledCard = styled(Card)`
  min-width: ${toRem(318)};
  min-height: ${toRem(270)};
  padding: ${toRem(theme.space['2xl'])};

  &:hover,
  &:focus-within {
    border-color: ${theme.color.secondary[400]};
  }

  button {
    padding: 0 ${toRem(theme.space['3xl'])};
    margin-top: ${toRem(theme.space.sm)};
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const StyledCardIcon = styled(CardIcon)`
  margin-right: 0;
  width: ${toRem(68)};
  height: ${toRem(68)};

  svg {
    width: ${toRem(36)};
    height: ${toRem(36)};
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  min-height: ${toRem(105)};

  h3 {
    font-size: ${toRem(theme.font.size['2xl'])};
    line-height: ${lineHeight(theme.font.size['2xl'])};
    margin-bottom: ${toRem(theme.space.xs)};
    text-transform: capitalize;
  }

  p {
    color: ${theme.color.neutral[500]};
    font-size: ${toRem(theme.font.size.md)};
    line-height: ${lineHeight(theme.font.size.md)};
    text-align: center;
  }
`;

const StyledButton = styled(Button)`
  &:focus {
    background-color: ${theme.color.primary[600]};
    color: ${theme.color.white};
  }
`;

const PayoutMethodCard = ({ disabled, icon, isLoading, title, subTitle, onClick, tooltipId }: IPayoutMethodCardProps) => (
  <StyledCard data-cy="payout-method-card">
    <CardContent>
      {icon && <StyledCardIcon icon={icon} bgColor={theme.color.secondary[25]} fill={theme.color.secondary[400]} />}
      <TitleContainer>
        <CardValue>{title}</CardValue>
        {subTitle && <Text>{subTitle}</Text>}
      </TitleContainer>
      <StyledButton label="Select" size="small" isLoading={isLoading} disabled={disabled || isLoading} data-cy={`${title}-payout-button`} onClick={onClick} tooltipId={tooltipId} />
    </CardContent>
  </StyledCard>
);

export default PayoutMethodCard;
